import { render, staticRenderFns } from "./deleteShopType.vue?vue&type=template&id=2b5a4fd1"
import script from "./deleteShopType.vue?vue&type=script&lang=js"
export * from "./deleteShopType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports